import { render, staticRenderFns } from "./PlusButton.vue?vue&type=template&id=70df6725&"
import script from "./PlusButton.vue?vue&type=script&lang=js&"
export * from "./PlusButton.vue?vue&type=script&lang=js&"
import style0 from "./PlusButton.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports